import axios from 'axios';

export default
{
    getAllBuildings: async function(){
        const token=localStorage.getItem('accessToken');
        const url='/Catalogs/GetAllBuildings';
        const response=await axios.get(url, {crossDomain:true,  headers:{ 'Authorization':'Bearer '+token}});
        return response.data;
    },
    addBuilding:async function(building)
    {
        const token=localStorage.getItem('accessToken');
        const url='/Catalogs/AddBuilding';
        const response=await axios.post(url, building,{crossDomain:true, headers:{ 'Authorization':'Bearer '+token}});
        return response.data;
    },
    getFloors: async function()
    {
        const token=localStorage.getItem('accessToken');
        const url=`/Catalogs/GetFloors`;
        const response=await axios.get(url, {crossDomain:true, headers:{ 'Authorization':'Bearer '+token}});
        return response.data;
    },
    addFloor: async function(floor){
        const token=localStorage.getItem('accessToken');
        const url='/Catalogs/AddFloor';
        const response=await axios.post(url,floor,{crossDomain:true, headers:{ 'Authorization':'Bearer '+token}});
        return response.data;
    },
    getLeakTestGroups: async function()
    {
        const token=localStorage.getItem('accessToken');
        const url=`/Catalogs/GetLeakTestGroups`;
        const response=await axios.get(url, {crossDomain:true, headers:{ 'Authorization':'Bearer '+token}});
        return response.data;
    },
    getIsotopes: async function(){
        const token=localStorage.getItem('accessToken');
        const url='/Catalogs/GetIsotopes';
        const response=await axios.get(url, {crossDomain:true, headers:{ 'Authorization':'Bearer '+token}});
        return response.data;
    },
    addIsotope: async function(isotope){
        const token=localStorage.getItem('accessToken');
        const url='/Catalogs/AddIsotope';
        const response=await axios.post(url,isotope,{crossDomain: true, headers:{ 'Authorization':'Bearer '+token}});
        return response.data;
    },
    getHolders: async function(){
        const token=localStorage.getItem('accessToken');
        const url='/Catalogs/GetHolders';
        const response=await axios.get(url, {crossDomain:true, headers:{ 'Authorization':'Bearer '+token}});
        return response.data;
    },
    addHolder: async function(holder){
        const token=localStorage.getItem('accessToken');
        const url='/Catalogs/AddHolder';
        const response=await axios.post(url,holder,{crossDomain: true, headers:{ 'Authorization':'Bearer '+token}});
        return response.data;
    },
    getAllUsers: async function(){
        const token=localStorage.getItem('accessToken');
        const url='/Catalogs/GetAllUsers';
        const response=await axios.get(url,{crossDomain:true, headers:{ 'Authorization':'Bearer '+token}});
        return response.data;
    },
    getInstallOptions: async function(){
        const url='/Catalogs/GetInstallOptions';
        const token=localStorage.getItem('accessToken');
        const response =await axios.get(url,{crossDomain:true, headers:{ 'Authorization':'Bearer '+token}});
        return response.data;
    },
    addRadiation: async function(newRadiation)
    {
        
        const url='/radiations';
        const token=localStorage.getItem('accessToken');
        const response=await axios.post(url,newRadiation,{crossDomain:true, headers:{ 'Authorization':'Bearer '+token}});
        console.log('Response status',response.status);
        return response;
    },
    getRadiationList: async function()
    {  
        const token=localStorage.getItem('accessToken');
        const url='/radiations/GetRadiationList';
        const response=await axios.get(url,{crossDomain:true, headers:{ 'Authorization':'Bearer '+token}});
        return response;
    },
    getRadiation:async function(radiationId)
    {
        const url=`/radiations/${radiationId}/getRadiation/`;
        const token=localStorage.getItem('accessToken');
        const response=await axios.get(url,{crossDomain:true, headers:{ 'Authorization':'Bearer '+token}});
        return response;
    },
    UpdateRadiation: async function(radiationId,radiation)
    {
        const url=`/radiations/${radiationId}/updateRadiation`;
        const token=localStorage.getItem('accessToken');
        const response=await axios.put(url,radiation,{crossDomain:true, headers:{ 'Authorization':'Bearer '+token}});
        console.log('Response status',response.status);
        return response;
    },
    updateRadiationDispose: async function(radiationId, dispose){
        const token=localStorage.getItem('accessToken');
        const url=`/radiations/${radiationId}/updateRadiationDispose`;
        const response=await axios.put(url, dispose,{crossDomain:true, headers:{ 'Authorization':'Bearer '+token}})
        return response;
    },
    updateRadiationUser: async function(userChanging)
    {
        const url='/radiations/UpdateRadiationUser';
        const token=localStorage.getItem('accessToken');
        const response=await axios.put(url,userChanging,{crossDomain:true, headers:{ 'Authorization':'Bearer '+token}});
        return response;
    },
    addCheckWorkflow: async function(radiationId,checkWorkFlow)
    {
        const url=`/radiations/${radiationId}/AddCheckWorkFlow`;
        const token=localStorage.getItem('accessToken');
        const response=await axios.post(url,checkWorkFlow,{crossDomain:true,  headers:{ 'Authorization':'Bearer '+token}});
        console.log('Response status',response.status);
        return response; 
    },
    getCheckWorkFlows: async function(radiationId){
        const url=`/radiations/${radiationId}/GetCheckWorkFlows`;
        const token=localStorage.getItem('accessToken');
        const response=await axios.get(url,{crossDomain:true, headers:{ 'Authorization':'Bearer '+token}});
        console.log('Response status',response.status);
        return response; 
    }

}